var lingue = require('./lingue.json')

export function linguaT(tag, slug, array_variabili){
    let testo_tradotto = lingue[slug][tag]

    for (let i = 0; i < array_variabili.length; i++) {
        const variabile = array_variabili[i];
        testo_tradotto = testo_tradotto.replaceAll(`[${i}]`, `${variabile}`)
    }

    return testo_tradotto

}